export interface IAddProducts {
  productName: string
  productCode: string
  brand: string
  commodity: string
  utility: string
  contractType: string
  customerType: string
  unit: number
  rate: number
  secondRate: number
  term: number
  earlyTerminationFee: number
  serviceFee: number
  script: string
  language: string
  added: string
  deposit: string
  startDate: Date
  endDate: Date
  note1: string
  note2: string
  note3: string
  note4: string
  note5: string
}

export const defaultProductDetails = {
  productName: '',
  productCode: '',
  brand: '',
  brandId: '',
  commodity: 'Electric',
  utility: '',
  contractType: '',
  customerType: '',
  unit: '',
  ebillingMethod: '',
  ecode: '',
  rate: '',
  rateMaximum: '',
  rateMinimum: '',
  secondRate: '',
  term: '',
  termMinimum: '',
  termMaximum: '',
  earlyTerminationFee: '',
  serviceFee: '',
  added: '',
  gutility: '',
  gcontractType: '',
  gunit: '',
  gunitId: '',
  grate: '',
  grateMaximum: '',
  grateMinimum: '',
  gsecondRate: '',
  gterm: '',
  gtermMaximum: '',
  gtermMinimum: '',
  gearlyTerminationFee: '',
  gserviceFee: '',
  gadded: '',
  gdeposit: '',
  gbillingMethod: '',
  gcode: '',
  language: '',
  script: '',
  deposit: '',
  startDate: '',
  endDate: '',
  note1: '',
  note2: '',
  note3: '',
  note4: '',
  note5: '',
  isDynamicProduct: false,
}
export const solarProductDetails = {
  productName: '',
  product: '',
  customerType: '',
  solarFarmName: '',
  productCode: '',
  billingMethod: '',
  discount: '',
  dealSourceTier: '',
  availableCustomers: '',
  creditCheckRequired: '',
  state: '',
  utility: '',
  productStatus: '',
  script: '',
  note1: '',
  benefitProgramId: '',
}
